import { FC } from 'react'
import lodash from "lodash";
import parse from 'html-react-parser';
import {Avatar} from "../core";
import moment from "moment";

interface ServiceFeedbackViewProps {
  feedback: {
    _id: string;
    code: string;
    description: string;
    region?: {
      _id: string;
      name: string;
      code: string;
    },
    district?: {
      _id: string;
      name: string;
      code: string;
    },
    contactPerson?: {
      fullName: string;
      phoneNumber: string;
      emailAddress: string;
    },
    servicePointCode: string;
    personnel: {
      _id: string;
      code: string;
      firstName: string;
      lastName: string;
      emailAddress: string;
      phoneNumber: string;
      profileImageUrl: string;
    },
    farmingOutContractor: {
      _id: string;
      name: string;
      code: string;
    },
    contractor: {
      _id: string;
      name: string;
      code: string;
    },
    status: string;
    type: string;
    serviceItem?: {
      _id: string;
      code: string;
    }
    answers: ({
      question: string
      type: string
      answer: string | string[]
    })[]
    submittedAt: Date;
    createdAt: Date;
    updatedAt: Date;
  }
}

export const ServiceFeedbackView: FC<ServiceFeedbackViewProps> = ({ feedback }) => {

  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div className=''>
        <div className='mt-3'>
          <div className='border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200'>
            <div className='grid grid-cols-4 gap-6 mt-2'>
              <div className='col-span-1'>
                <span className='block text-sm font-light text-gray-700'>
                  Code
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.code || "N/A"}
                </div>
              </div>
              <div className=''>
                <span className='block text-sm font-light text-gray-700'>
                  Service Item Type
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.type || "N/A"}
                </div>
              </div>
              <div className=''>
                <span className='block text-sm font-light text-gray-700'>
                  Service Item Code
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.serviceItem?.code || "N/A"}
                </div>
              </div>
              <div className='col-span-4'>
                <span className='block text-sm font-light text-gray-700'>
                  Description
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback.description || "N/A"}
                </div>
              </div>
              <div className='col-span-2'>
                <span className='block text-sm font-light text-gray-700'>
                  Date Survey was Delivered
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.createdAt
                    ? moment(feedback?.createdAt).format("DD/MM/YYYY")
                    : "N/A"}
                </div>
              </div>
              <div className='col-span-2'>
                <span className='block text-sm font-light text-gray-700'>
                  Date Feedback was Submitted
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.submittedAt
                    ? moment(feedback?.submittedAt).format("DD/MM/YYYY")
                    : "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='pt-6'>
        <div className='flex justify-between items-center cursor-pointer'>
          <div>
            <h3 className='text-md leading-6 font-normal text-gray-900 dark:text-gray-100'>
              Customer Information
            </h3>
            <p className='mt-1 text-xs text-gray-500'>Details about the customer who submitted the feedback</p>
          </div>
          <div />
        </div>
        <div className='mt-6'>
          <div className='border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200'>
            <div className='grid grid-cols-4 gap-6 mt-2'>
              <div className='col-span-1'>
                <span className='block text-sm font-light text-gray-700'>
                  Full Name
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.contactPerson?.fullName || "N/A"}
                </div>
              </div>
              <div className=''>
                <span className='block text-sm font-light text-gray-700'>
                  Phone Number
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.contactPerson?.phoneNumber || "N/A"}
                </div>
              </div>
              <div className='col-span-2'>
                <span className='block text-sm font-light text-gray-700'>
                  Email Address
                </span>
                <div className='mt-1 block w-full sm:text-sm'>
                  {feedback?.contactPerson?.emailAddress || "N/A"}
                </div>
              </div>
              <div className={"col-start-1"}>
                <span className="block text-sm font-light text-gray-700">
                  Region Code
                </span>
                <div className="mt-1 block w-full sm:text-sm">
                  {feedback?.region?.code || "N/A"}
                </div>
              </div>
              <div>
                <span className="block text-sm font-light text-gray-700">
                  Region Name
                </span>
                <div className="mt-1 block w-full sm:text-sm">
                  {feedback?.region?.name || "N/A"}
                </div>
              </div>
              <div>
                <span className="block text-sm font-light text-gray-700">
                  District Code
                </span>
                <div className="mt-1 block w-full sm:text-sm">
                  {feedback?.district?.code || "N/A"}
                </div>
              </div>
              <div>
                <span className="block text-sm font-light text-gray-700">
                  District Name
                </span>
                <div className="mt-1 block w-full sm:text-sm">
                  {feedback?.district?.name || "N/A"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        feedback.personnel ? (
          <div className='pt-6'>
            <div className='flex justify-between items-center cursor-pointer'>
              <div>
                <h3 className='text-md leading-6 font-normal text-gray-900 dark:text-gray-100'>
                  Agent Information
                </h3>
                <p className='mt-1 text-xs text-gray-500'>Details about the ECG staff whose work was reviewed</p>
              </div>
              <div />
            </div>
            <div className='mt-6'>
              <div className='border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200'>
                <div className='grid grid-cols-4 gap-6 mt-2'>
                  <div className='row-span-2 items-center justify-center flex flex-col'>
                    <Avatar
                      alt={
                        (feedback?.personnel?.lastName && feedback?.personnel?.firstName)
                          ? [feedback?.personnel?.lastName, feedback?.personnel?.firstName].join(" ")
                          : "N/A"
                      }
                      src={
                        feedback?.personnel.profileImageUrl ||
                        ""
                      }
                      size='lg'
                    />
                  </div>
                  <div className=''>
                    <span className='block text-sm font-light text-gray-700'>
                      Full Name
                    </span>
                    <div className='mt-1 block w-full sm:text-sm'>
                      {(feedback?.personnel?.lastName && feedback?.personnel?.firstName)
                        ? [feedback?.personnel?.firstName, feedback?.personnel?.lastName].join(" ")
                        : "N/A"}
                    </div>
                  </div>
                  <div className=''>
                    <span className='block text-sm font-light text-gray-700'>
                      Phone Number
                    </span>
                    <div className='mt-1 block w-full sm:text-sm'>
                      {feedback?.personnel?.phoneNumber || "N/A"}
                    </div>
                  </div>
                  <div className={"col-start-2"}>
                    <span className="block text-sm font-light text-gray-700">
                      Staff Code
                    </span>
                    <div className="mt-1 block w-full sm:text-sm">
                      {feedback?.personnel?.code || "N/A"}
                    </div>
                  </div>
                  <div className='col-span-2'>
                    <span className='block text-sm font-light text-gray-700'>
                      Email Address
                    </span>
                    <div className='mt-1 block w-full sm:text-sm'>
                      {feedback?.personnel?.emailAddress || "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null
      }
      <div className='pt-3'>
        <div className='flex justify-between items-center cursor-pointer'>
          <div>
            <h3 className='text-md leading-6 font-normal text-gray-900 dark:text-gray-100'>
              Survey Answers
            </h3>
          </div>
          <div />
        </div>
        <div className='mt-3'>
          <div className='space-y-6 divide-y divide-gray-200'>
            {feedback.answers.map((answer, idx) => (
              <>
                <div className='grid grid-cols-4 gap-6 pt-6 first:border-t first:border-t-gray-200'>
                  <div className='col-span-2'>
                    <span className='block text-sm font-light text-gray-700'>
                      Question
                    </span>
                    <div className='mt-1 block w-full sm:text-sm'>
                      {answer.question || "N/A"}
                    </div>
                  </div>
                  <div className=''>
                    <span className='block text-sm font-light text-gray-700'>
                      Question Type
                    </span>
                    <div className='mt-1 block w-full sm:text-sm'>
                      { lodash.startCase(answer.type) || "N/A"}
                    </div>
                  </div>
                  <div className='col-start-1 col-span-4'>
                    <span className='block text-sm font-light text-gray-700'>
                      Answer
                    </span>
                    <div className='mt-1 block w-full sm:text-sm'>
                      {
                        answer.answer
                          ? lodash.isArray(answer.answer)
                            ? answer.answer.join(",  ")
                            : parse(`${answer.answer}`)
                          : "N/A"
                      }
                    </div>
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ServiceFeedbackView